/* eslint-disable no-param-reassign */

import { queryStrategy } from '../data';

export function makeCore ({
    makeRoutes, makeWelcome, home, forbidden, onSetupApp, api, mediainfoUrl, uploadOptions, imageUrl,
}) {
    return {
        namespaced: true,
        state: {
            loading: false,
            error: false,
            apiUrl: api.url,
            imageUrl,
            mediainfoUrl,
            uploadOptions,
        },
        getters: {
            routes (state, getters, rootState) {
                return makeRoutes(rootState.solution.config);
            },
            welcome () {
                return makeWelcome();
            },
            home () {
                return home;
            },
            forbidden () {
                return forbidden;
            },
            /**
             * Whether we should let the user in on an auth-protected page.
             * Requires to be logged in. Additionally, if solution has a casting,
             * also requires either to have a confirmed linked application or to be admin
             */
            shouldGrantAccess (state, getters, rootState, rootGetters) {
                if (!rootGetters['user/isConnected']) {
                    return { grant: false, reason: 'User is not logged in.' };
                }

                if (rootGetters['solution/hasCasting']) {
                    if (rootGetters['user/isAdmin']) {
                        return { grant: true, reason: 'User is admin.' };
                    } else if (!rootState.casting.application) {
                        return { grant: false, reason: 'User does not have a linked casting application.' };
                    } else if (!rootGetters['casting/applicationConfirmed']) {
                        return { grant: false, reason: `User's application is ${rootState.casting.application.status.toLowerCase()}` };
                    } else {
                        return { grant: true, reason: `User's application is ${rootState.casting.application.status.toLowerCase()}` };
                    }
                } else {
                    return { grant: true, reason: 'Platform is open' };
                }
            },
        },
        mutations: {
            SET_LOADING (state, loading) {
                state.loading = loading;
            },
            SET_ERROR (state, error) {
                state.error = error;
            },
        },
        actions: {
            /**
             * Populates the store so that the app is ready to be used. Runs only once
             */
            async init ({ commit, dispatch }) {
                const rootDispatch = (name, args) => dispatch(name, args, { root: true });

                try {
                    commit('SET_LOADING', true);
                    // Retrieve solution and configuration
                    await rootDispatch('solution/updateSolution');
                    // Setup upload info
                    await rootDispatch('project/updateUploadInformation');
                    // Setup tutorial
                    await rootDispatch('tutorial/updateTutorial');
                    // Setup tracking
                    await rootDispatch('tracking/init');
                    // Retrieve user
                    await rootDispatch('user/updateUser');
                    await rootDispatch('user/setupUser');
                    // When page is coming from the login page, dispatch the `onLogin` action
                    if (queryStrategy('login')) {
                        await rootDispatch('user/onLogin');
                    }
                    // Optional setup
                    await onSetupApp();
                } catch (err) {
                    commit('SET_ERROR', err);
                    // Forward the error
                    throw err;
                } finally {
                    commit('SET_LOADING', false);
                }
            },
        },
    };
}
